import { Route } from "react-router-dom";
import { AUTH_ROUTES } from "./routes";

// Routes
import {
  LoginPage,
  AuthRedirectPage,
  SignOutPage,
  UnauthorizedPage,
} from "./pages";

export const LoggedOutAuthRoutes = (
  <>
    <Route path={AUTH_ROUTES.LOGIN.path} element={<LoginPage />} />
    <Route path={"*"} element={<AuthRedirectPage />} />
  </>
);

export const LoggedInAuthRoutes = (
  <>
    <Route
      path={AUTH_ROUTES.UNAUTHORIZED.path}
      element={<UnauthorizedPage />}
    />
    <Route path={AUTH_ROUTES.SIGN_OUT.path} element={<SignOutPage />} />
  </>
);
